import { useEffect, useRef } from 'react';

export function useCancelPromise() {
  const cancelPromise = useRef(false);

  useEffect(() => {
    cancelPromise.current = false;

    return () => {
      cancelPromise.current = true;
    };
  }, []);

  return cancelPromise;
}
